import { render, staticRenderFns } from "./UPC.vue?vue&type=template&id=1ae7387c&scoped=true&"
import script from "./UPC.vue?vue&type=script&lang=js&"
export * from "./UPC.vue?vue&type=script&lang=js&"
import style0 from "./UPC.vue?vue&type=style&index=0&id=1ae7387c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae7387c",
  null
  
)

export default component.exports